import { Grid, Typography, Box } from "@mui/material";

import tubeEqImage from "../../../static/images/distant_bass_suite/tube-equalizer.webp"

const textColor = "#000"

const EQBanner = () => {
  return <>
    <Box sx={{ p: 5, background: "radial-gradient(circle, #eee 0%,#aaa 100%)", justifyContent: "center", alignItems: "center", color: textColor }} >
      <Grid container justifyContent={"center"} alignItems={"center"} spacing={4}>
        <Grid item xs={12} md={7}>
          <Box component="img" src={tubeEqImage} alt="Tube Equalizer" sx={{ display: "block", width: "100%", height: "auto" }} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography sx={{ textAlign: { xs: "center", md: "left" }, mb: 3 }} variant="h3">Tube Equalizer</Typography>
          <Typography sx={{ textAlign: { xs: "center", md: "left" } }} variant="h6">Shape your bass with a tube equalizer built for broad, musical tone control. Independently boost and attenuate selectable low and high frequencies to add weight, tame harshness, or bring out exactly the right amount of definition.</Typography>
        </Grid>
      </Grid>

    </Box >
  </ >
}

export default EQBanner;
